import { observer } from "mobx-react-lite"
import { useContext, useState } from "react";
import { Context } from "..";

const Registration = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const { store } = useContext(Context);
    // const [showPassword, setShowPassword] = useState(false);
    
    const registration = async (event) => {
        event.preventDefault();
        if (password !== confirmPassword) return;

        try {
            let result = await store.registration(email, password);
            if (result.error === false) window.location.replace('/');
        } catch (err) {
            console.log("registration error:", err);
        }
    }

    return (
        <>
            <h1>Регистрация</h1>
            <input type="email" placeholder="Email" name="Email" value={email} onChange={(e) => setEmail(e.target.value)}/><br />
            <input type="password" placeholder="Пароль" name="Пароль" value={password} onChange={(e) => setPassword(e.target.value)}/><br />
            <input type="password" placeholder="Подтверждение пароля" name="Пароль" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)}/><br />
            <button onClick={registration}>Зарегистрироваться</button>
            <div>Уже есть аккаунт? <a href="/login">Войти</a></div>
        </>
    )
}

export default observer(Registration);